// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiProtocol: 'http:',
  apiHostname: '127.0.0.1',
  // apiUrl: 'http://localhost:4563',
  // apiUrl: 'http://192.168.10.179:8080/api/v1', // Toloka
  // apiUrl: 'http://127.0.0.1:8080/api/v1',
  // apiUrl: 'http://192.168.1.192:8080/api/v1', // BinblioTech
  // apiUrl: 'http://192.168.0.56:8080/api/v1',
  // apiUrl: null,
  apiUrl: 'https://api.mobiteach.ltd/api/v1', //DEV
  apiPort: 4563,
  apiTimeout: 25000,
  apiPrefix: '',
  staticPrefix: '/',
  // hostUrl: 'http://127.0.0.1'
  // hostUrl: 'https://horizon.live.dev.codeblue.ventures'
  IMAGE_MAX_SIZE: 8 * 1024 * 1024, // 8Mb
  IMAGE_MAX_WIDTH: 40000, // px
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
